import PropTypes from 'prop-types';
import { Alert } from 'antd';
import CustomImage from './CustomImage';
import warning from '@src/assets/icons/icon-profil-warning.svg';
import '@src/styles/components/customAlertWarning.scss';

const CustomAlertWarning = ({ className, message, ...props }) => {
    return (
        <Alert
            {...props}
            banner
            showIcon={false}
            className={`alert-warning ${className}`}
            message={
                <div className="alert-message-contain">
                    <div className="alert-message-contain-icon">
                        <CustomImage src={warning} />
                    </div>
                    <div className="alert-message-contain-description" dangerouslySetInnerHTML={{ __html: message }} />
                </div>
            }
        />
    );
};

CustomAlertWarning.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string.isRequired,
};

CustomAlertWarning.defaultProps = {
    className: '',
};

export default CustomAlertWarning;